module.exports = __webpack_public_path__ + "static/media/scenario-4.213d4d7e.png";